import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLine } from "../components/Reveal";
import { IMAGES } from "../lib/content";
import { useLang } from "../lib/i18n";

export const Hero = () => {
  const ref = useRef(null);
  const { c } = useLang();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.12]);

  return (
    <section id="home" ref={ref} className="relative h-[100svh] overflow-hidden" data-testid="hero-section">
      <motion.div style={{ y, scale }} className="absolute inset-0">
        <img src={IMAGES.hero} alt="Paulina and Louie" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#2C3552]/45 via-[#2C3552]/25 to-[#2C3552]/60" />
      </motion.div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6 text-[#FAFAF1]">
        <MaskedLine delay={0.2} className="text-[11px] sm:text-xs uppercase tracking-[0.5em] mb-8 font-light">
          {c.hero.overline}
        </MaskedLine>
        <h1 className="font-serif-display font-light leading-[1.02]" data-testid="hero-names">
          <MaskedLine delay={0.4} className="text-5xl sm:text-7xl lg:text-8xl">
            Diana Paulina
          </MaskedLine>
          <MaskedLine delay={0.5} className="italic text-4xl sm:text-5xl lg:text-6xl text-[#F4B8C6] my-1 sm:my-3">
            &amp;
          </MaskedLine>
          <MaskedLine delay={0.6} className="text-5xl sm:text-7xl lg:text-8xl">
            Anthony Louie
          </MaskedLine>
        </h1>
        <MaskedLine delay={1.1} className="mt-10 font-serif-display italic text-xl sm:text-2xl font-light">
          {c.hero.married}
        </MaskedLine>
        <MaskedLine delay={1.3} className="mt-6 text-[11px] sm:text-xs uppercase tracking-[0.4em]">
          {c.hero.dateline}
        </MaskedLine>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2, duration: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-[#FAFAF1]/80"
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 2.2, ease: "easeInOut" }}
          className="w-px h-12 bg-gradient-to-b from-transparent via-[#FAFAF1]/70 to-transparent mx-auto"
        />
      </motion.div>
    </section>
  );
};
